import { MutationFunction, useMutation, useQuery, useQueryClient } from 'react-query';

import { defaultError, defaultSuccess } from '../../../libs/utils';
import { getEventMaterials, updateEventMaterial } from '../../../services/api/eventMaterials';
import { deleteFrequentPassageRequest } from '../../../services/api/frequentPassageRequests';
import { FREQUENT_PASSAGE_REQUESTS_ALL_QUERY_KEY } from './useFrequentPassageRequests';
import { REGISTRATION_FREQUENT_PASSAGE_REQUESTS_ALL_QUERY_KEY } from './useRegistrationFrequentPassageRequests';

export type DeleteMaterialRequestParams = {
  frequentPassageRequestId: number;
};

export const useDeleteFrequentPassageRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ frequentPassageRequestId }: DeleteMaterialRequestParams) =>
      deleteFrequentPassageRequest(frequentPassageRequestId),
    onError: (error: any, variables, context) => {
      defaultError(`Failed to delete frequent passage request: ${error?.message}`);
    },

    onSuccess: (data, variables, context) => {
      defaultSuccess('Frequent passage request deleted!');
      queryClient.invalidateQueries(REGISTRATION_FREQUENT_PASSAGE_REQUESTS_ALL_QUERY_KEY);
      queryClient.invalidateQueries(FREQUENT_PASSAGE_REQUESTS_ALL_QUERY_KEY);
      queryClient.invalidateQueries('frequent-passage-requests');
    },
  });
};
